import { Host, h } from '@stencil/core';
export class AibaBazaarvoiceScript {
  constructor() {
    this.handleLoadScriptBazaarVoice = async () => {
      const scriptPresent = document.querySelector('#rr-widget');
      if (!scriptPresent) {
        const script = document.createElement('script');
        script.src = `${this.bvData.scriptUrl}/${this.bvData.bazaarvoiceEnv}/${this.bvData.locale}/bv.js`;
        script.id = 'rr-widget';
        typeof window !== 'undefined' ? (!window.BV ? document.body.appendChild(script) : null) : null;
        await document.querySelector('#rr-widget');
      }
    };
    this.upc = undefined;
    this.scriptUrl = undefined;
    this.bvData = undefined;
  }
  componentDidLoad() {
    this.handleLoadScriptBazaarVoice();
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  static get is() { return "aiba-bazaarvoice-script"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-bazaarvoice-script.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-bazaarvoice-script.css"]
    };
  }
  static get properties() {
    return {
      "upc": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "upc",
        "reflect": false
      },
      "scriptUrl": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "script-url",
        "reflect": false
      },
      "bvData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "bv-data",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-bazaarvoice-script.js.map
